module.exports = __webpack_public_path__ + "static/gavilanwork4-50a54ae668ce9239fc2bf1e5bbc474f8.jpg";